import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';

import { URL } from '../../assets/js/constants'
import TituloPagina from '../../components/layout/TituloPagina';
import LoadingOverlay from '../../components/layout/LoadingOverlay';

export default function OnboardingStripeRedirect() {

    const { idNegocio } = useParams();
    const [isProcessing, setIsProcessing] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [urlStripe, setUrlStripe] = useState('');

    useEffect(() => {
        if (idNegocio > 0) handleGerarUrlOnboardStripe();
    }, [idNegocio]);

    const handleGerarUrlOnboardStripe = async () => {
        // 1. Ativa o loading ANTES de iniciar a chamada à API
        setLoadingMessage('Comunicando com Stripe...');
        setIsProcessing(true);
        try {
            // 2. Faz a chamada ao backend Spring Boot
            const response = await axios.get(`${URL}/payment/v1/onboarding-stripe-redirect/${idNegocio}`);

            if (response.data) {
                const { urlStripe } = response.data;
                if(urlStripe) {
                    window.location.assign(urlStripe);
                } else {
                    <h1>Houve um erro ao tentar redirecionar para o site da Stripe. Tente novamente em alguns instantes.</h1>
                }
            }

        } catch (error) {
            // Tratamento de erro
            <h1>Houve um erro ao tentar redirecionar para o site da Stripe. Tente novamente em alguns instantes.</h1>
        } 
    }

    return (
        <LoadingOverlay
            open={isProcessing}
            message={loadingMessage}
        />
    )
}